import { render, staticRenderFns } from "./MarcaModal.vue?vue&type=template&id=1fe25751&scoped=true"
import script from "./MarcaModal.vue?vue&type=script&lang=js"
export * from "./MarcaModal.vue?vue&type=script&lang=js"
import style0 from "./MarcaModal.vue?vue&type=style&index=0&id=1fe25751&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe25751",
  null
  
)

export default component.exports